import { t } from '@lingui/macro';
import { RoutePaths } from 'types/enums';
import { TrendingLink } from './type';

export const trendingInstruments: TrendingLink[] = [
    {
        to: `${RoutePaths.Instruments}/vocals`,
        label: t({ id: `vocals` }),
    },
    {
        to: `${RoutePaths.Instruments}/drums`,
        label: t({ id: `drums` }),
    },
    {
        to: `${RoutePaths.Instruments}/guitars`,
        label: t({ id: `guitars` }),
    },
    {
        to: `${RoutePaths.Instruments}/bass`,
        label: t({ id: `bass` }),
    },
    {
        to: `${RoutePaths.Instruments}/synth`,
        label: t({ id: `synth` }),
    },
    {
        to: `${RoutePaths.Instruments}/keys`,
        label: t({ id: `keys` }),
    },
];

export const trendingGenres: TrendingLink[] = [
    {
        to: `${RoutePaths.Genres}/trap`,
        label: t({ id: `trap` }),
    },
    {
        to: `${RoutePaths.Genres}/pop`,
        label: t({ id: `pop` }),
    },
    {
        to: `${RoutePaths.Genres}/rnb`,
        label: t({ id: `rnb` }),
    },
    {
        to: `${RoutePaths.Genres}/house`,
        label: t({ id: `house` }),
    },
    {
        to: `${RoutePaths.Genres}/techno`,
        label: t({ id: `techno` }),
    },
    {
        to: `${RoutePaths.Genres}/soul`,
        label: t({ id: `soul` }),
    },
];
export const trendingSfxs: TrendingLink[] = [
    {
        to: `${RoutePaths.Sfxs}/voices`,
        label: t({ id: `voices` }),
    },
    {
        to: `${RoutePaths.Sfxs}/ambience`,
        label: t({ id: `ambience` }),
    },
    {
        to: `${RoutePaths.Sfxs}/environment`,
        label: t({ id: `environment` }),
    },
    {
        to: `${RoutePaths.Sfxs}/industrial`,
        label: t({ id: `industrial` }),
    },
];

export const trendingBpmAndKeys: TrendingLink[] = [
    {
        to: `${RoutePaths.Browse}?bpmlowerbound=90&bpmupperbound=90`,
        label: '90 BPM',
    },
    {
        to: `${RoutePaths.Browse}?bpmlowerbound=120&bpmupperbound=120`,
        label: '120 BPM',
    },
    {
        to: `${RoutePaths.Browse}?keyrootnote=C&keyquality=minor`,
        label: 'C minor',
    },
    {
        to: `${RoutePaths.Browse}?keyquality=minor`,
        label: 'Min',
    },
    {
        to: `${RoutePaths.Browse}?keyquality=major`,
        label: 'Maj',
    },
];
